__turbopack_context__.v({
  "bar": "ta78WG_bar",
  "bars": "ta78WG_bars",
  "label": "ta78WG_label",
  "labels": "ta78WG_labels",
  "wrapper": "ta78WG_wrapper",
});
